import { ErrorView } from "../views/errorView.jsx";
import {observer} from "mobx-react-lite";

const Error = observer(

    function ErrorRender(props) {
        return <ErrorView/>
    })

export {Error}